<template>
	<div
		class="range-input"
	>
		<div class="range-input__value">
			<span
				v-if="prefix"
				class="range-input__value-prefix"
				v-html="prefix"
			/>
			<span
				class="range-input__value-value"
				v-html="displayValue || value"
			/>
		</div>
		<input
			ref="input"
			type="range"
			:id="id"
			:name="name"
			class="range-input__input"
			:required="required"
			:disabled="disabled"
			:readonly="readonly"
			:min="min"
			:max="max"
			:step="step"
			:value="value"
			@input="onInput"
			@change="onInput"
			@focus="onFocus"
			@blur="onBlur"
			@keyup="onKeyup"
			@keydown="onKeydown"
			@mouseup="onMouseup"
			:style="`--percent: ${percent}%;`"
		/>
	</div>
</template>

<script>
export default {
	props: {
		id: String,
		name: String,
		displayValue: Number | String,
		value: Number | String,
		required: Boolean,
		disabled: Boolean,
		readonly: Boolean,
		max: Number | String,
		min: Number | String,
		step: Number | String,
		prefix: String,
		label: String,
		labelOption: String,
		error: Boolean,
	},
	data() {
		return {
			focused: false,
		}
	},
	computed: {
		percent() {
			return Math.round(100 / (this.max - this.min) * this.value);
		}
	},
	model: {
		prop: 'value',
		event: 'input'
	},
	methods: {
		focus() {
			this.$refs.input.focus();
		},
		blur() {
			this.$refs.input.blur();
		},
		onInput(e) {
			this.$emit('input', e.target.value);
		},
		onFocus(e) {
			this.focused = true;
			this.$emit('focus', e);
		},
		onBlur(e) {
			this.focused = false;
			this.$emit('blur', e);
		},
		onKeyup(e) {
			this.$emit('keyup', e);
		},
		onKeydown(e) {
			this.$emit('keydown', e);
		},
		onMouseup(e) {
			this.blur();
		},
	}
}
</script>

<style>

</style>